module.exports = "html {\n    background: red;\n}\n\n/* HIDDEN */\n\n.wufoo .info {\n    display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/css/formularios.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/css/formularios.css
// module chunks = styles